import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Brewery } from '../../interfaces/brewery';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-brewery-logo',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './brewery-logo.component.html',
  styleUrl: './brewery-logo.component.scss'
})
export class BreweryLogoComponent {
  @Input() brewery: Brewery | undefined
}
